exports.components = {
  "component---src-pages-add-ons-js": () => import("./../../../src/pages/add-ons.js" /* webpackChunkName: "component---src-pages-add-ons-js" */),
  "component---src-pages-docs-js": () => import("./../../../src/pages/docs.js" /* webpackChunkName: "component---src-pages-docs-js" */),
  "component---src-pages-download-js": () => import("./../../../src/pages/download.js" /* webpackChunkName: "component---src-pages-download-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-docs-template-js": () => import("./../../../src/templates/DocsTemplate.js" /* webpackChunkName: "component---src-templates-docs-template-js" */)
}

